import { CrawlerModalView } from '../../components/CrawlerModalView';
import {
  useDeleteDetailStore,
  useDetailStore,
  useEditBaseStore,
  useEditDetailStore,
} from '../../hooks';

export const CrawlerModal = () => {
  const detailStore = useDetailStore();
  const deleteDetailStore = useDeleteDetailStore();
  const editBaseStore = useEditBaseStore();
  const editDetailStore = useEditDetailStore();

  return (
    <CrawlerModalView
      {...detailStore}
      baseInputModalViewProps={editBaseStore}
      baseConfirmModalViewProps={editBaseStore}
      detailsModalViewProps={editDetailStore}
      detailConfirmProps={editDetailStore}
      detailDeleteProps={deleteDetailStore}
    />
  );
};
